import React, { useCallback } from 'react';
import { CardWrapper } from './styles';
import { DynamicObjectType } from 'core/types/common';
import { Divider, Space } from 'antd';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';
import TotalOrderItem from '../components/TotalOrderItem';
import { useSelector } from '@redux';

const ReturnInformation = ({ data, title, address }: DynamicObjectType) => {
  const cities = useSelector(
    (state) => state.config.address,
  ) as DynamicObjectType[];

  const addressInfo = useCallback(() => {
    const selectedCity = cities?.find(
      (city) => city?.id === address?.provinceId,
    );
    return {
      citie: selectedCity?.name,
      district: selectedCity?.districts?.find(
        (district) => district?.id === address?.districtId,
      )?.name,
      ward: selectedCity?.districts
        ?.find((district) => district?.id === address?.districtId)
        ?.wards?.find((ward) => ward?.id === address?.wardId)?.name,
    };
  }, [cities, data]);

  return (
    <div>
      <CardWrapper
        title={title}
        // extra={
        //   <Button
        //     onClick={() => setVisible(true)}
        //     type="text"
        //     icon={<FontAwesomeIcon icon={faPenToSquare} />}
        //   />
        // }
      >
        <div className="order-info-box__content">
          {address && (
            <>
              <div className="flex flex-center-between">
                <div className="order-info-box__content-item">{`${address?.firstName} ${address?.lastName}`}</div>
                {/* {!data?.isPickup && data?.status === 'pending' && (
                  <Button
                    onClick={() => setVisible(true)}
                    type="text"
                    icon={<FontAwesomeIcon icon={faPenToSquare} />}
                  />
                )} */}
              </div>
              <div className="order-info-box__content-item text-secondary mb-[5px]">
                {address?.email}
              </div>
              <div className="order-info-box__content-item text-secondary mb-[5px]">
                {address?.telephone}
              </div>
            </>
          )}
          {address && (
            <>
              <div className="order-info-box__content-item break-all">
                {[
                  address?.addressLine2,
                  [
                    address?.addressLine1,
                    addressInfo()?.ward,
                    addressInfo()?.district,
                    addressInfo()?.citie,
                  ].join(', '),
                ].join(' | ')}
              </div>
            </>
          )}
        </div>
        <Divider className="mb-2.5 mt-2.5" />
        <Space size={10} direction="vertical" className="w-full">
          <TotalOrderItem
            title="Expected delivery partner"
            value={data?.shippingCarrier?.name || '-'}
          />
          <TotalOrderItem
            title="Shipping no"
            value={data?.deliveryCode || '-'}
          />
        </Space>
      </CardWrapper>
    </div>
  );
};

export default ReturnInformation;
